/*-------------------- Powerups --------------------------*/
import Powerup from '@FreeRider/Track/Powerups/Powerup';
import Checkpoint from '@FreeRider/Track/Powerups/Checkpoint';

/*--------------------- Renderer ----------------------*/
import CheckpointRenderer from '@FreeRider/Renderers/PowerupRenderers/CheckpointRenderer';


/**
 * Portal Renderer
 */
class PowerupRenderer
{
    public render(powerup: Powerup)
    {
        if (powerup instanceof Checkpoint)
        {
            return CheckpointRenderer.render();
        }
    }
}


export default PowerupRenderer;